import LinkExpired from '@images/link-expired.svg';
import { Button, Icon, useTranslation } from '@testsigma/atoms';
import { useNavigate } from 'react-router-dom';

const LinkExpiredComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const navigateHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className='flex justify-center w-full h-full'>
      <div className='w-2/4 h-11/12 flex flex-col justify-center'>
        <div className='flex justify-center'>
          <img src={LinkExpired} alt='Link Expired' />
        </div>

        <div className=' font-semibold flex justify-center pt-6'>
          {t('common.link_expired_title')}
        </div>
        <div className='text-secondary-500 text-center font-normal text-sm pt-4'>
          {t('common.link_expired_message')}
        </div>
        <div className='flex justify-center pt-8'>
          <Button onClick={navigateHome}>
            {t('common.go_to_testsigma.label')}
            <Icon name='open-in-new' className='text-xl ml-2'></Icon>
          </Button>
        </div>
      </div>
      <div
        className='absolute bottom-8 flex justify-center text-2xs text-secondary-500'
        dangerouslySetInnerHTML={{
          __html: t('common.error_boundary_footer_text'),
        }}
      />
    </div>
  );
};

export default LinkExpiredComponent;
